<template>
    <v-alert v-if="user && user.impersonating_user"
             type="warning"
             tile
             :icon="false"
             class="py-1 mb-0">
        <div class="d-flex justify-space-between align-center">
            <div class="mr-4">
                You are impersonating {{ user.name }} ({{ user.id }})
            </div>
            <div>
                <v-form action="/impersonate/leave"
                        method="get">
                    <v-btn type="submit"
                           x-small>
                        Leave
                    </v-btn>
                </v-form>
            </div>
        </div>
    </v-alert>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'user',
        ])
    }
}
</script>
